module.exports = __webpack_public_path__ + "media/images/lp/1/donation4-title-pc-1446043cf64917959d751fa190965dcc.png";